export class SliderTitleStyle {
  size = '';
  decoration = '';
  decorationColor = '';
  font = 'tb-font-primary';
  color = '';
  marginTop = 'uk-margin-top';
  transition = '';

  static normalize(styles: Partial<SliderTitleStyle>): SliderTitleStyle {
    const pureStyles = new SliderTitleStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
